import { useMutation } from '@tanstack/react-query';
import { closeSnackbar, enqueueSnackbar } from 'notistack';

import { http } from '@/services/http';

export interface SendShareEmailParams {
  content: string;
  recipient: string;
  url: string;
  extraPayload?: Record<string, string>;
}

export const useSendShareEmail = () => {
  return useMutation({
    mutationKey: ['share', 'send-email'] as const,

    mutationFn: async ({ content, recipient, url, extraPayload }: SendShareEmailParams) => {
      await http.go.post('/share', { content, recipient, url, ...extraPayload });
    },
    onMutate: () => {
      enqueueSnackbar('Email is sending, please wait...', {
        variant: 'loading',
        persist: true,
        key: 'loading'
      });
    },
    onSuccess: () => {
      enqueueSnackbar('Email sent!', { variant: 'success', autoHideDuration: 5000 });
    },
    onError: () => {
      enqueueSnackbar('Something went wrong!', { variant: 'error', autoHideDuration: 5000 });
    },
    onSettled: () => {
      closeSnackbar('loading');
    }
  });
};
